import {createContext, useContext} from 'react';
import {InterpreterOptions} from 'xstate';

export type Options = Partial<InterpreterOptions>;
export const MachineOptionsContext = createContext<Options>({});
export const useMachineOptions = () => useContext(MachineOptionsContext);
